import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.metafont = bracketIndenting({
	line: "%",
})
